import React from "react";
import { Link } from "react-router-dom";
import { useSettings } from "@/lib/settings";

export const Logo = ({ className = "", size = "md", chip = "auto" }) => {
  const { settings } = useSettings();
  const src = settings.logo_url || "/logo.png";
  const heights = { sm: "h-7", md: "h-9", lg: "h-14" };
  const h = heights[size] || heights.md;

  // chip: auto uses dark rounded background for contrast, "none" for transparent
  const wrapper =
    chip === "none"
      ? ""
      : "bg-ink-900 rounded-2xl px-3 py-1.5 brand-shadow";

  return (
    <Link
      to="/"
      className={`inline-flex items-center ${wrapper} ${className}`}
      data-testid="site-logo"
      aria-label="Malatya Mobilya Tasarım"
    >
      <img src={src} alt="Malatya Mobilya Tasarım" className={`${h} w-auto object-contain`} />
    </Link>
  );
};
